import { interval } from 'rxjs';
import { mergeMap, map } from 'rxjs/operators';
var RTCStats = /** @class */ (function () {
    function RTCStats(statsInterval, getStats, intervalProvider) {
        if (intervalProvider === void 0) { intervalProvider = interval; }
        this._previousQualityStats = new Map();
        this.NO_NETWORK = 0;
        this.BAD_NETWORK = 30;
        this.POOR_NETWORK = 60;
        this.FAIR_NETWORK = 80;
        this.GOOD_NETWORK = 90;
        this.GREAT_NETWORK = 100;
        // intervalProvider exists for tests to mock interval with
        // ideally we would use the rxjs test scheduler and marble tests, but overkill for now
        this._getStats = intervalProvider(statsInterval).pipe(mergeMap(getStats));
    }
    Object.defineProperty(RTCStats.prototype, "qualityStats", {
        get: function () {
            var _this = this;
            return this._getStats.pipe(map(function (stats) {
                var qualityScore = _this.GREAT_NETWORK;
                if (stats) {
                    // return empty map when no stats are retrieved
                    stats.forEach(function (stat) {
                        if ((stat.type === 'inbound-rtp' || stat.type === 'ssrc') && stat.mediaType === 'audio') {
                            qualityScore = Math.min(_this.computeQualityScore(stat), qualityScore);
                        }
                    });
                }
                // take overall lowest quality
                return Math.min(_this.computeConnectionScore(), qualityScore);
            }));
        },
        enumerable: true,
        configurable: true
    });
    RTCStats.prototype.computeConnectionScore = function () {
        if (!navigator.onLine) {
            return this.NO_NETWORK;
        }
        var score = this.GREAT_NETWORK;
        var connection = navigator.connection;
        if (!connection) {
            // network connection not supported, can't determine score
            // TO DO: Not return 100 once other browsers than Chrome are supported
            return score;
        }
        switch (connection.effectiveType) {
            case undefined:
                break;
            case '4g':
                score = this.GREAT_NETWORK;
                break;
            case '3g':
                score = this.POOR_NETWORK;
                break;
            default:
                score = this.BAD_NETWORK;
        }
        switch (connection.type) {
            case undefined:
                break;
            case 'none':
                return this.NO_NETWORK;
            case 'wifi':
            case 'ethernet':
                break;
            default:
                return Math.min(score, this.FAIR_NETWORK);
        }
        return score;
    };
    RTCStats.prototype.computeQualityScore = function (stat) {
        var previousQualityStat = this._previousQualityStats.get(stat.ssrc);
        var fractionLostScore = this.computeFractionLostScore(previousQualityStat, stat);
        var jitterScore = this.computeJitterScore(stat);
        var score = Math.min(this.GREAT_NETWORK, fractionLostScore, jitterScore);
        this._previousQualityStats.set(stat.ssrc, stat);
        return Math.floor(score);
    };
    RTCStats.prototype.computeFractionLostScore = function (previousQualityStat, stat) {
        var score = this.GREAT_NETWORK;
        if (previousQualityStat) {
            var packetsLostBetweenInterval = stat.packetsLost - previousQualityStat.packetsLost;
            var packetsSentReceivedBetweenInterval = 0;
            if (stat.packetsReceived && previousQualityStat.packetsReceived) {
                packetsSentReceivedBetweenInterval = stat.packetsReceived - previousQualityStat.packetsReceived;
            }
            else if (stat.packetsSent && previousQualityStat.packetsSent) {
                packetsSentReceivedBetweenInterval = stat.packetsSent - previousQualityStat.packetsSent;
            }
            // Compute score based on fractionLost
            if (packetsSentReceivedBetweenInterval !== 0) {
                score = (packetsSentReceivedBetweenInterval / (packetsSentReceivedBetweenInterval + packetsLostBetweenInterval)) * 100;
            }
        }
        else {
            // Compute score based on initial fractionLost
            if (stat.packetsReceived && stat.packetsReceived !== 0) {
                score = (stat.packetsReceived / (stat.packetsReceived + stat.packetsLost)) * 100;
            }
            if (stat.packetsSent && stat.packetsSent !== 0) {
                score = (stat.packetsSent / (stat.packetsSent + stat.packetsLost)) * 100;
            }
        }
        if (score !== this.GREAT_NETWORK) {
            // 1 or 2 packet lost should be a GOOD_NETWORK score
            score = Math.min(score, this.GOOD_NETWORK);
        }
        return score;
    };
    RTCStats.prototype.computeJitterScore = function (stat) {
        var score = this.GREAT_NETWORK;
        // Jitter defined in ms and chosen using known perceived quality values
        var jitter = stat.jitter || (stat.googJitterReceived || 0) / 1000;
        if (jitter > 0.035) {
            score = this.BAD_NETWORK;
        }
        else if (jitter > 0.025) {
            score = this.POOR_NETWORK;
        }
        else if (jitter > 0.015) {
            score = this.FAIR_NETWORK;
        }
        else if (jitter > 0.005) {
            score = this.GOOD_NETWORK;
        }
        return score;
    };
    return RTCStats;
}());
export { RTCStats };
//# sourceMappingURL=RTCStats.js.map